import { AdFormat } from '@openx/types/gqlTypes.ts';
import type { TFunction } from 'i18next';
import { type InferType, mixed, object } from 'yup';
import { getBaseFieldsValidation } from './baseValidation.ts';

// const VIDEO_MARKUP_TYPES = [MarkupType.Html, MarkupType.Vast, MarkupType.Xml, MarkupType.JavaScript];

export const getVideoCreativeSchema = (t: TFunction) => {
  return object({
    ...getBaseFieldsValidation(t),

    ad_format: mixed<typeof AdFormat.Video>()
      .oneOf([AdFormat.Video], t('Ad format must be video'))
      .required(t('Ad format is required')),

    // markup_type: mixed<MarkupType>()
    //   .oneOf(VIDEO_MARKUP_TYPES, t('Markup type must be one of: HTML, VAST, XML, or JavaScript for video creatives'))
    //   .required(t('Markup type is required')),
  }).strict();
};

/**
 * Type inference for Video creative form data
 * Does not include width or height fields
 */
export type VideoCreativeFormData = InferType<ReturnType<typeof getVideoCreativeSchema>>;
